import { Navigate } from "react-router-dom";

import {
  Home,
  UniversityGridView,
  UniversityListView,
  AddUniversity,
  EditUniversity,
  UniversityDetailsMain,
  Applications,
  ApplicationDetails,
  UpcomingMeetings,
  MeetingsSent,
  MeetingsReceived,
  RescheduleMeeting,
  MeetingDetails,
  AddMeeting,
  VisaInformation,
  VisaInfoList,
  EditVisaInfo,
  AddVisaInfo,
  CountryList,
  EditCountry,
  AddCountry,
  Chatbot,
  Settings,
  Notifications,
  Login,
  ForgotPassword,
  VerifyOTP,
  ResetPassword,
  Students,
  StudentDetails,
  Internships,
  Schools,
} from "../../containers";

export const routes = {
  protected: {
    home: "/home",

    universityGridView: "/universities/grid",
    universityListView: "/universities/list",
    addUniversity: "/universities/add-university",
    editUniversity: "/universities/edit-university/:id",

    universityDetails: "/universities/:id",

    upcomingMeetings: "/meetings/upcoming",
    meetingsSent: "/meetings/sent",
    meetingsReceived: "/meetings/received",
    rescheduleMeeting: "/meetings/reschedule-meeting",
    meetingdetails: "/meetings/meetingdetails",
    addMeeting: "/meetings/add-meeting",

    applications: "/applications",
    applicationDetails: "/applications/:id",

    visaInformation: "/visa-information",
    visaInformationDetails: "/visa-information/:id",
    addVisaInfo: "/visa-information/add",
    editVisaInfo: "/visa-information/edit-visa-info/:id",

    countries: "/country",
    editCountry: "/country/edit-country/:id",
    addCountry: "/country/add",

    chatbot: "/chatbot",

    notifications: "/notifications",

    settings: "/settings",

    students: "/students",
    studentDetailsGeneral: "/students/general/:id",
    studentDetailsApplications: "/students/applications/:id",
    studentDetailsMeetings: "/students/meetings/:id",
    studentDetailsProfileBuilder: "/students/profileBuilder/:id",

    internships: "/internships",

    schools: "/schools",
  },
  public: {
    // login
    login: "/login",

    // forgot pass
    resetPassword: "/reset-password",
    verifyOtp: "/verify-otp",
    forgotPassword: "/forgot-password",
  },
};

export const PROTECTED_ROUTES = [
  // home
  {
    path: routes.protected.home,
    exact: false,
    component: <Home />,
  },
  // university
  {
    path: routes.protected.universityGridView,
    exact: false,
    component: <UniversityGridView />,
  },
  {
    path: routes.protected.universityListView,
    exact: false,
    component: <UniversityListView />,
  },
  {
    path: routes.protected.addUniversity,
    exact: false,
    component: <AddUniversity />,
  },
  {
    path: routes.protected.editUniversity,
    exact: false,
    component: <EditUniversity />,
  },

  // uni details
  {
    path: routes.protected.universityDetails,
    exact: false,
    component: <UniversityDetailsMain />,
  },

  // meeting
  {
    path: routes.protected.upcomingMeetings,
    exact: false,
    component: <UpcomingMeetings />,
  },
  {
    path: routes.protected.meetingsReceived,
    exact: false,
    component: <MeetingsReceived />,
  },
  {
    path: routes.protected.meetingsSent,
    exact: false,
    component: <MeetingsSent />,
  },
  {
    path: routes.protected.rescheduleMeeting,
    exact: false,
    component: <RescheduleMeeting />,
  },
  {
    path: routes.protected.meetingdetails,
    exact: false,
    component: <MeetingDetails />,
  },
  {
    path: routes.protected.addMeeting,
    exact: false,
    component: <AddMeeting />,
  },
  // applications
  {
    path: routes.protected.applications,
    exact: false,
    component: <Applications />,
  },
  {
    path: routes.protected.applicationDetails,
    exact: false,
    component: <ApplicationDetails />,
  },
  // visaInformation
  {
    path: routes.protected.visaInformation,
    exact: false,
    component: <VisaInfoList />,
  },
  {
    path: routes.protected.visaInformationDetails,
    exact: false,
    component: <VisaInformation />,
  },
  {
    path: routes.protected.editVisaInfo,
    exact: false,
    component: <EditVisaInfo />,
  },
  {
    path: routes.protected.addVisaInfo,
    exact: false,
    component: <AddVisaInfo />,
  },
  // country
  {
    path: routes.protected.countries,
    exact: false,
    component: <CountryList />,
  },
  {
    path: routes.protected.editCountry,
    exact: false,
    component: <EditCountry />,
  },
  {
    path: routes.protected.editVisaInfo,
    exact: false,
    component: <EditVisaInfo />,
  },
  {
    path: routes.protected.addCountry,
    exact: false,
    component: <AddCountry />,
  },
  // chatbot
  {
    path: routes.protected.chatbot,
    exact: false,
    component: <Chatbot />,
  },
  // notifications
  {
    path: routes.protected.notifications,
    exact: false,
    component: <Notifications />,
  },
  // settings
  {
    path: routes.protected.settings,
    exact: false,
    component: <Settings />,
  },
  // students
  {
    path: routes.protected.students,
    exact: false,
    component: <Students />,
  },
  {
    path: routes.protected.studentDetailsGeneral,
    exact: false,
    component: <StudentDetails />,
  },
  {
    path: routes.protected.studentDetailsApplications,
    exact: false,
    component: <StudentDetails />,
  },
  {
    path: routes.protected.studentDetailsMeetings,
    exact: false,
    component: <StudentDetails />,
  },
  {
    path: routes.protected.studentDetailsProfileBuilder,
    exact: false,
    component: <StudentDetails />,
  },
  // jobs
  {
    path: routes.protected.internships,
    exact: false,
    component: <Internships />,
  },
  // schools
  {
    path: routes.protected.schools,
    exact: false,
    component: <Schools />,
  },

  {
    path: "*",
    exact: false,
    component: <Navigate to={routes.protected.home} />,
  },
];

export const PUBLIC_ROUTES = [
  // login
  {
    path: routes.public.login,
    exact: false,
    component: <Login />,
  },
  // forgot pass
  {
    path: routes.public.forgotPassword,
    exact: false,
    component: <ForgotPassword />,
  },
  {
    path: routes.public.verifyOtp,
    exact: false,
    component: <VerifyOTP />,
  },
  {
    path: routes.public.resetPassword,
    exact: false,
    component: <ResetPassword />,
  },
  {
    path: "*",
    exact: false,
    component: <Navigate to={routes.public.login} />,
  },
];
